<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">TEST PILOTS</h1>
<h1 class="title1">OF THE</h1>
<h1 class="title2">JET AGE</h1>
<p class="sub-title">Men Who Heralded a New Era in Aviation</p>
<p class="author">COLIN HIGGS and BRUCE VIGAR</p>
<div class="img_containert">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?6fde13ed